import React, { useState } from "react";
import { TopButtonProps } from "./TopButton";
import { ColorValue, StyleSheet } from "react-native";
import { PressableWrap } from "../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import { Text } from "native-base";
import { webFont } from "../../../Universal/API/API";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
import { verticalScale_ } from "../../../Universal/API/Scale";
import Animated, { FadeIn, FadeInLeft, FadeOut, FadeOutLeft, FadeOutRight } from "react-native-reanimated";

export const LeftSideButton: React.FC<TopButtonProps> = ({ text, onPress }) => {
    const {currentWidth: width, scaleAll} = useAppContext()
    const [color, setColor] = useState<ColorValue>("#1E1E1E");

    // Responsive sizing
    const textSize = width > 800 ? 20 * scaleAll : 15 * scaleAll;
    const paddingVertical = width > 800 ? 24 * scaleAll : 20 * scaleAll;
    const marginVertical = width > 800 ? 14 * scaleAll : 10 * scaleAll;

    return (
        <PressableWrap

            onPress={() => { if (onPress) onPress(); }}
            setColor={setColor}
            style={[styles.main, {
                marginVertical: marginVertical,
                paddingVertical: paddingVertical,
            }]}
        >
            <Animated.Text
                key={text + '_LeftSideButton'}
                entering={FadeInLeft.duration(300)}
                exiting={FadeOutRight.duration(300)}
                style={[styles.text,{
                    fontSize: textSize,
                    color: color,
                }]}
            >
                {text}
            </Animated.Text>
        </PressableWrap>
    );
};


const styles = StyleSheet.create({
    main: {
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    text: {
        textAlign: 'center',
        marginVertical: verticalScale_(20),
        fontFamily: webFont("Inter"),
        fontWeight: "600",
    }
})